import React from 'react';

const AnomalyPredictionTable = ({ predictions }) => {
    const formatValue = (value) => {
        if (value === null || value === undefined) return '-';
        return `${value}%`;
    };

    const getValueColor = (value) => {
        if (value === null || value === undefined) return 'rgba(255, 255, 255, 0.5)';
        if (value > 70) return '#F44336';
        if (value > 40) return '#FF9800';
        if (value > 20) return '#FFEB3B';
        return '#4CAF50';
    };

    return (
        <div className="bob-prediction-table">
            <h4>Anomaly Predictions</h4>
            <table>
                <thead>
                    <tr>
                        <th>Anomaly Level</th>
                        <th>Next 24h</th>
                        <th>Next 30 days</th>
                        <th>Next 6 months</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Reach 20%</td>
                        <td style={{ color: getValueColor(predictions?.to_20?.['24h']) }}>
                            {formatValue(predictions?.to_20?.['24h'])}
                        </td>
                        <td style={{ color: getValueColor(predictions?.to_20?.['30d']) }}>
                            {formatValue(predictions?.to_20?.['30d'])}
                        </td>
                        <td style={{ color: getValueColor(predictions?.to_20?.['6mo']) }}>
                            {formatValue(predictions?.to_20?.['6mo'])}
                        </td>
                    </tr>
                    <tr>
                        <td>Reach 50%</td>
                        <td style={{ color: getValueColor(predictions?.to_50?.['24h']) }}>
                            {formatValue(predictions?.to_50?.['24h'])}
                        </td>
                        <td style={{ color: getValueColor(predictions?.to_50?.['30d']) }}>
                            {formatValue(predictions?.to_50?.['30d'])}
                        </td>
                        <td style={{ color: getValueColor(predictions?.to_50?.['6mo']) }}>
                            {formatValue(predictions?.to_50?.['6mo'])}
                        </td>
                    </tr>
                    <tr>
                        <td>Reach 80%</td>
                        <td style={{ color: getValueColor(predictions?.to_80?.['24h']) }}>
                            {formatValue(predictions?.to_80?.['24h'])}
                        </td>
                        <td style={{ color: getValueColor(predictions?.to_80?.['30d']) }}>
                            {formatValue(predictions?.to_80?.['30d'])}
                        </td>
                        <td style={{ color: getValueColor(predictions?.to_80?.['6mo']) }}>
                            {formatValue(predictions?.to_80?.['6mo'])}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default AnomalyPredictionTable;
